import { InlineCompareButtonsBase } from "./inline-compare-button-base"
import { useReviewDecisions } from "./review-decisions"

export function InlineCompareButtonsWithGroupId({
    idFromGroup,
    to,
    from,
    rendered,
    schedule,
    canSave,
    popupEditor,
    groupReviewId,
    referenceId,
    taskId,
    latestTaskAudit,
}) {
    const decisions = useReviewDecisions()
    const audit = decisions.useDecision({ referenceId, groupReviewId, taskId })

    return (
        <InlineCompareButtonsBase
            idFromGroup={idFromGroup}
            to={to}
            from={from}
            rendered={rendered}
            schedule={schedule}
            canSave={canSave}
            popupEditor={popupEditor}
            groupReviewId={groupReviewId}
            referenceId={referenceId}
            taskId={taskId}
            audit={audit}
            latestTaskAudit={latestTaskAudit}
        />
    )
}
